var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GOOGLE_MAPS_PROXY = "api/v2/google-maps";
const CUSTOMERS_APP_GOOGLE_MAPS_PROXY = "api/v2/washdayapp/google-maps";
function authConfig() {
    return {
        headers: { Authorization: `Bearer ${this.apiToken}` },
    };
}
export const autocompleteCustomersApp = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield this.axiosInstance.post(`${CUSTOMERS_APP_GOOGLE_MAPS_PROXY}/autocomplete`, payload, authConfig.call(this));
    });
};
export const placeDetailsCustomersApp = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield this.axiosInstance.post(`${CUSTOMERS_APP_GOOGLE_MAPS_PROXY}/place-details`, payload, authConfig.call(this));
    });
};
export const geocodeCustomersApp = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield this.axiosInstance.post(`${CUSTOMERS_APP_GOOGLE_MAPS_PROXY}/geocode`, payload, authConfig.call(this));
    });
};
export const reverseGeocodeCustomersApp = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield this.axiosInstance.post(`${CUSTOMERS_APP_GOOGLE_MAPS_PROXY}/reverse-geocode`, payload, authConfig.call(this));
    });
};
export const autocomplete = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield this.axiosInstance.post(`${GOOGLE_MAPS_PROXY}/autocomplete`, payload, authConfig.call(this));
    });
};
export const placeDetails = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield this.axiosInstance.post(`${GOOGLE_MAPS_PROXY}/place-details`, payload, authConfig.call(this));
    });
};
export const geocode = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield this.axiosInstance.post(`${GOOGLE_MAPS_PROXY}/geocode`, payload, authConfig.call(this));
    });
};
export const reverseGeocode = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield this.axiosInstance.post(`${GOOGLE_MAPS_PROXY}/reverse-geocode`, payload, authConfig.call(this));
    });
};
